import { IssuerService, LoginResponse, SSO } from "./IssuerService";
import { ParsedQuery } from "query-string";
import { LoggerFactory, RemoteApi } from "lego-gui-lib";
import { RedirectState } from "./auth";
import { getBaseUrl } from "../../common/common";
import { changeTranslation } from "../i18n/i18n";

const log = LoggerFactory.create("ExternalSSOService");

export class ExternalSSOService implements IssuerService {
  public issuer = "ExternalSSO";

  private remoteApi: RemoteApi;

  public constructor(api: RemoteApi) {
    this.remoteApi = api;
  }

  public async login(
    params: ParsedQuery,
    redirectState: RedirectState
  ): Promise<LoginResponse> {
    const issuer = redirectState.issuer;
    const accessCode = params.access_code as string;
    const current_language = params.currentLanguage as string;
    const baseUrl = getBaseUrl();
    const redirectUrl = `${baseUrl}/loginRedirect`;

    const response = await this.remoteApi.postMethod<any>(
      "/public/auth/login",
      {
        accessCode: accessCode,
        redirectUri: redirectUrl,
        issuer: issuer
      }
    );

    // change only when not saved in browser
    if (current_language && window.localStorage.getItem("language") === null) {
      changeTranslation(current_language);
    }

    return Promise.resolve({ redirectUrl: redirectUrl, csrf: response.csrf });
  }

  public async redirect(sso: SSO): Promise<void> {
    const baseUrl = getBaseUrl();
    const primaryRedirect = encodeURIComponent(`${baseUrl}/loginRedirect`);
    const loginRedirect = `${sso.url}${sso.loginPath}?client_id=${sso.clientId}&scope=${sso.scope}&redirect_uri=${primaryRedirect}`;
    log.debug("redirecting to", loginRedirect);
    window.location.href = loginRedirect;
  }

  public async logoutRedirect(sso: SSO): Promise<void> {
    const logoutRedirect = `${sso.url}${sso.logoutPath}`;
    log.debug("redirecting to", logoutRedirect);
    window.location.href = logoutRedirect;
  }
}
